import React from 'react';

function JoinButton() {
  return (
    <a href="https://campus.hellorubric.com/?s=14325" target="_blank" rel="noopener noreferrer" className="no-underline">
      <button className="bg-[#32b069] text-white px-4 py-2 mr-4 rounded-lg hover:bg-[#2a9658] transition-colors shadow-lg shadow-green-600/50 hvr-grow">
        Join Now
      </button>
    </a>
  );
}

export default JoinButton;
